import { CALL_NOTE_TEMPLATES } from "../../lib/callNoteTemplates";

const slug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

// Row of one-tap note template chips. `onPick(label)` fires with the chosen
// template; the parent decides how to apply it (append to its note field).
export default function NoteTemplateChips({ onPick, className = "" }) {
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid="note-template-chips">
      {CALL_NOTE_TEMPLATES.map((t) => (
        <button
          key={t}
          type="button"
          data-testid={`note-chip-${slug(t)}`}
          onClick={() => onPick(t)}
          className="text-[11px] font-semibold px-2.5 py-1 rounded-full border border-slate-200 text-slate-600 bg-white hover:bg-slate-100 hover:border-slate-300 transition-colors"
        >
          {t}
        </button>
      ))}
    </div>
  );
}
